<template>
  <div class="date-wrapper">
    <div class="btn-areas">
      <button
        v-for="preset in presets"
        :key="preset.key"
        :class="{ active: active === preset.key }"
        @click="applyPreset(preset)"
      >
        {{ preset.label }}
      </button>
    </div>
    <div class="date-areas">
      <Datepicker
        v-model="range"
        format="yyyy-MM-dd"
        range
        placement="bottom"
        class="custom-datepicker dp__theme_dark"
        :clearable="true"
        :close-on-scroll="true"
        :enable-time-picker="false"
        :max-date="today"
        @update:model-value="onPickerChange"
      >
        <template #input-icon>
          <img
            src="@/assets/images/icons/calendar.svg"
            alt="calendar"
            style="width: 20px; height: 20px; margin-left: 5px"
          />
        </template>
      </Datepicker>
      <button class="reset" @click="resetRange">
        <!-- <img src="@/assets/images/icons/refresh.svg" alt="" /> -->
        {{ $t("trading.table.reset") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import dayjs from "dayjs";
import { ref, watch, defineProps, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
const props = defineProps({
  activeTab: String,
});
const { t } = useI18n();
const store = useStore();
const presets = ref([
  { key: "day", label: t("trading.table.day"), amount: 1, unit: "day" },
  { key: "week", label: t("trading.table.week"), amount: 1, unit: "week" },
  { key: "month", label: t("trading.table.month"), amount: 1, unit: "month" },
]);
const today = dayjs().toDate();
const active = ref("day");
const range = ref([dayjs().subtract(1, "day").toDate(), dayjs().toDate()]);
const resetRange = () => {
  range.value = [dayjs().subtract(1, "day").toDate(), dayjs().toDate()];
  active.value = "day";
};
const applyPreset = ({ key, amount, unit }) => {
  active.value = key;
  range.value = [dayjs().subtract(amount, unit).toDate(), dayjs().toDate()];
};
const onPickerChange = (value) => {
  if (!Array.isArray(value) || value.length !== 2) {
    active.value = null;
    return;
  }

  range.value = value;
  active.value = null;
};
watch(range, (val) => {
  if (!Array.isArray(val) || val.length !== 2) {
    return;
  }
  const [start, end] = val;
  const s = dayjs(start).format("YYYY-MM-DD");
  const e = dayjs(end).format("YYYY-MM-DD");
  store.commit("user_history/setDate", { s, e });
});
watch(
  () => props.activeTab,
  () => {
    resetRange();
  },
);
onMounted(() => {
  const s = dayjs(range.value[0]).format("YYYY-MM-DD");
  const e = dayjs(range.value[1]).format("YYYY-MM-DD");
  store.commit("user_history/setDate", { s, e });
});
</script>
<style lang="scss" scoped>
button {
  color: var(--txt-default-color);
  background-color: transparent;
  padding: 8px 16px;
  font-family: var(--main-font-Light), "Noto Sans JP", "Noto Sans SC";

  border-radius: 4px;
  border: 1px solid var(--border-color);

  // &:hover {
  //   background-color: #bdbdbd;
  //   color: #000;
  // }

  &.active {
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
  }

  &.reset {
    min-width: 50px;
    background-color: #000000;
    color: #fff;
    font-weight: 400;
    white-space: nowrap;

    /* &:hover {
            background-color: #fff;
            color: #000;
            border: 1px solid #000;
        } */
  }
}

.date-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-areas,
.date-areas {
  display: flex;
  align-items: center;
  gap: 5px;
}

:deep(.dp__theme_light) {
  --dp-primary-color: #ff7519;
  --dp-hover-color: #ff7519;
  --dp-background-color: var(--bs-body-bg);
  --dp-text-color: var(--txt-default-color);
  --dp-secondary-color: var(--line-color);
}

:deep(.custom-datepicker *) {
  font-size: 15px;
}

:deep(.custom-datepicker .dp__input) {
  max-width: 230px;
  background-color: transparent;
  color: var(--txt-default-color);
  border: 1px solid var(--bs-board-bg);
}

:deep(.custom-datepicker .dp__action_row) {
  padding: 10px 12px;
}

:deep(.custom-datepicker .dp__action_button) {
  padding: 5px 16px;
  height: auto;
  border-radius: 6px;
}

@media screen and (max-width: 600px) {
  .date-wrapper {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
</style>
